export { default } from "./BaseInputFile.vue";
